module.exports = __webpack_public_path__ + "img/power-armor-mk2.76e55ea6.png";